import { useState } from "react";
import { useDebounce } from "./useDebounce";

export const useDebouncedSearch = (delay = 300) => {
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, delay);

  return {
    searchTerm,
    setSearchTerm,
    debouncedSearchTerm,
  };
};
